import { useEffect, useRef } from 'react';

/**
 * useFillInInteractiveTypeTransition
 * - Memindahkan effect transisi (dragpin -> clickable) dari QuestionsForm.
 * - IMPORTANT: tidak mengubah logic existing.
 */
export function useFillInInteractiveTypeTransition(params) {
  const {
    type,
    isInteractiveEnabled,
    interactiveType,
    clickableType,
    dispatch,
    setField,
    CLICKABLE_LENGTH_BY_TYPE,
    resetChoiceAndAnswer,
  } = params;

  // Track perubahan interactive_type untuk handle transisi mode (dragpin -> clickable)
  const prevInteractiveTypeRef = useRef(interactiveType);

  useEffect(() => {
    const prev = prevInteractiveTypeRef.current;
    const next = interactiveType;

    // Simpan dulu untuk render berikutnya
    prevInteractiveTypeRef.current = next;

    // Fokus: hanya saat fill_in_the_blanks + interactive aktif
    const isFillIn = type === 'fill_in_the_blanks';
    const isInteractive = isInteractiveEnabled;

    if (!isFillIn || !isInteractive) return;

    // ✅ Kalau pindah dari dragpin -> clickable, bersihkan nilai dragpin yang nyangkut di answer/choice
    if (prev === 'dragpin' && next === 'clickable') {
      // Clear field yang hanya relevan untuk dragpin (biar state form konsisten)
      dispatch(setField({ field: 'room_count', value: '' }));
      dispatch(setField({ field: 'pin_count', value: '' }));
      // ✅ Clear detail dragpin agar tidak nyangkut
      dispatch(setField({ field: 'interactive_detail', value: {} }));

      // Reset sesuai panjang clickable_type (kalau belum dipilih, fallback 1 dulu)
      const clickableLen = CLICKABLE_LENGTH_BY_TYPE[clickableType] || 1;
      resetChoiceAndAnswer(clickableLen);

      return;
    }
  }, [
    type,
    interactiveType,
    clickableType,
    dispatch,
    resetChoiceAndAnswer,
    isInteractiveEnabled,
    setField,
    CLICKABLE_LENGTH_BY_TYPE,
  ]);
}
